import * as React from "react";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { CommonHelper, Dictionary } from "../../../../../../../react-core/Helpers/CommonHelper";
import { CookieHelper } from "../../../../../../../react-core/Helpers/CookieHelper";
import { FullScreenTableModeButton } from "../../../../../../../react-core/Html/Components/FullScreenTableModeButton";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { addYears } from "../../../../../../../react-core/utils/date";
import { Guid } from "../../../../../../../react-core/Utils/Guid";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ServiceValidationError } from "../../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { Document } from "../../../../../../../Wrap/Models/Domains/Documents/Document";
import { DocumentsLibrary } from "../../../../../../../Wrap/Models/Domains/Documents/DocumentsLibrary";
import { DocumentType } from "../../../../../../../Wrap/Models/Domains/Documents/DocumentType";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { DateRange } from "../../../../../../Shared/Components/DateRange";
import { ErrorMessagePopup } from "../../../../../../Shared/Components/ErrorMessagePopup";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeleton } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeleton";
import { ITableConfig, Table } from "../../../../../../Shared/Table/Table";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { UserStore } from "../../../../../Stroes/Variable";
import { DocumentAction } from "./Action/DocumentAction";
import { DocumentFileAction } from "./Action/DocumentFileAction";
import { DocumentsFilters } from "./Components/DocumentsFilter";
import { FileUploader } from "./Components/FileUploader";
import { Constants, DocumentStatusTypeToMap, DocumentTypeOptions } from "./Resource/Constant";
import {
    ConsolidatedAccountStore,
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../../Store/Variable";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import {
    isConsolidate,
    orderHeadAccountGroupByInvestorType,
    selectedHeadAccounts,
} from "../Common/PortfolioDashboardHelper";
import { PresentationViewButton } from "../Common/PresentationViewButton";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { Urls } from "../../../../../Urls";
import { DateOptions } from "../../../../../../Shared/Components/Resource/Contents";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import { Objects } from "../../../../../../../react-core/Utils/Objects";

interface IPortfolioDashboardDocumentsState {
    userInfo: User;
    from: Date;
    to: Date;
    data: DocumentsLibrary;
    dateSelected: string;
    fromInception: boolean;
    isLoading: boolean;
    currentPage: number;
    documentType: Dictionary[];
    toggleFilter: any;
    isShowErrorMessage: boolean;
    errorMessage: string;
    isPopUp: boolean;
    selectedHierarchyId: string;
    headAccountSelected: string;
}

interface IPortfolioDashboardDocumentsProps extends IPortfolioDashboardComponentProps {
    isProspect: boolean;
}

export class PortfolioDashboardDocuments extends PortfolioDashboardComponent<
    IPortfolioDashboardDocumentsProps,
    IPortfolioDashboardDocumentsState
> {
    intervalID;
    constructor(props: any) {
        super(props);
        this.initState();
    }
    initState() {
        this.state = {
            userInfo: UserStore.getUserInfo(),
            from: addYears(new Date(), -1),
            to: new Date(),
            dateSelected: "4",
            fromInception: false,
            isLoading: true,
            data: null,
            currentPage: 1,
            documentType: this.initializeFilter(),
            toggleFilter: new Object(),
            isShowErrorMessage: false,
            errorMessage: "",
            isPopUp: false,
            selectedHierarchyId: null,
            headAccountSelected: null,
        };
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentWillUnmount() {
        clearTimeout(this.intervalID);
    }

    componentDidMount() {
        this.getData();
        this.intervalID = setInterval(() => {
            const documents: Document[] = (this.state.data?.Documents || []).filter(
                (x) =>
                    x.Status == "Pending" ||
                    x.Status == "Running" ||
                    x.Status == "Allocated" ||
                    x.Status == "PendingDelayed" ||
                    x.Status == "PendingHold"
            );
            const taskRequestIds = [];
            documents.map((item, index) => {
                taskRequestIds.push(item.TaskRequestId);
            });
            if (taskRequestIds.length > 0) {
                this.getDocuments(this.state.selectedHierarchyId, taskRequestIds);
            }
        }, 6000);
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Documents
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Documents,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .documents.getUrl(),
                    pageTitle: `${document.title} - client - documents`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    private initializeFilter(): Dictionary[] {
        return [{ key: "0", value: "All" }];
    }

    getData(selectedSubAccountHierarchyIds?: string[]) {
        const inprogressAccounts = PortfolioDashboardStore.getInProgressAccounts();
        const allAccounts = orderHeadAccountGroupByInvestorType(PortfolioDashboardStore.getData());
        const multiSelection = selectedSubAccountHierarchyIds ?? PortfolioDashboardMultiSelectionStore.getData();
        const isConsolidated = isConsolidate();
        let selectedHeadAccountsArray = selectedHeadAccounts(multiSelection, allAccounts).concat(inprogressAccounts);
        if (isConsolidated) {
            selectedHeadAccountsArray = [ConsolidatedAccountStore.getData()].concat(selectedHeadAccountsArray);
        }
        const urlHierarchyId = getQueryParameters()["hierarchyid"];
        const { entityId, hierarchyLevel } = HierarchyIdHelper.generateHierarchyId(urlHierarchyId);
        let headAccountSelected,
            subAccountSelected = null;
        if (hierarchyLevel === HierarchyLevelName.Account) {
            headAccountSelected = urlHierarchyId;
            subAccountSelected = urlHierarchyId;
        } else if (hierarchyLevel === HierarchyLevelName.SubAccount) {
            allAccounts.forEach((x) => {
                if (x.SubAccounts.find((s) => s.HierarchyId == urlHierarchyId)) {
                    headAccountSelected = x.HierarchyId;
                    return;
                }
            });
            subAccountSelected = urlHierarchyId;
        } else {
            //default set as the first head account
            headAccountSelected = selectedHeadAccountsArray[0]?.HierarchyId;
            if (isConsolidated) {
                headAccountSelected = ConsolidatedAccountStore.getData()?.HierarchyId;
            }
            const allSubAccounts =
                selectedHeadAccountsArray.find((o) => o.HierarchyId == selectedHeadAccountsArray[0]?.HierarchyId)
                    ?.SubAccounts || [];
            const subAccounts = allSubAccounts.filter((ele) => multiSelection.includes(ele.HierarchyId));
            let _sub = selectedHeadAccountsArray[0]?.HierarchyId;
            if (subAccounts.length > 0 && allSubAccounts.length !== subAccounts.length) {
                _sub = subAccounts?.[0].HierarchyId;
            }
            subAccountSelected = _sub;
        }
        const { minDate } = DateRange.getLeastDate(subAccountSelected, isConsolidated);
        const minDateWithoutTime = this.getMinDateWithoutTime(minDate);
        const initDateRange = DateRange.initializeDateRange(minDateWithoutTime);

        this.setState({
            headAccountSelected: headAccountSelected,
            selectedHierarchyId: subAccountSelected,
            from: initDateRange.from,
            to: initDateRange.to,
            dateSelected: initDateRange.dateSelected,
            fromInception: initDateRange.fromInception,
        });
    }

    private getMinDateWithoutTime(d: Date) {
        return new Date(JsonDateParser.toJsonDateNoOffset(d).toString().slice(0, 10));
    }

    private getDocuments(selectedSubAccountHierarchyIds?: string, taskRequestIds?: Array<number>) {
        const { from, to, currentPage, documentType } = this.state;
        const _from = JsonDateParser.toJsonDate(new Date(from));
        const _to = JsonDateParser.toJsonDateNoOffset(to);
        const minRow = (currentPage - 1) * 10 + 1;
        const maxRow = currentPage * 10;
        if (!selectedSubAccountHierarchyIds) {
            DocumentAction.getProspectDocuments(
                this.props.customerid,
                _from,
                _to,
                minRow,
                maxRow,
                (result: DocumentsLibrary) => {
                    this.setState({
                        data: result,
                        isLoading: false,
                    });
                }
            );
        } else {
            let searchquery = "";
            if (documentType.filter((o) => o.key === "0").length === 0) {
                const array = [];
                for (const item of documentType) {
                    array.push(item.key);
                }
                searchquery = array.join(",");
            }

            if (this.state.selectedHierarchyId == this.state.headAccountSelected) {
                // if head account selected,include all subaccount in service call as well
                const list = [selectedSubAccountHierarchyIds];
                const inprogressAccounts = PortfolioDashboardStore.getInProgressAccounts();
                const allAccounts = orderHeadAccountGroupByInvestorType(PortfolioDashboardStore.getData());
                const multiSelection = PortfolioDashboardMultiSelectionStore.getData();
                const selectedHeadAccountsArray = selectedHeadAccounts(multiSelection, allAccounts).concat(
                    inprogressAccounts
                );
                const subAccounts =
                    selectedHeadAccountsArray.find((o) => o.HierarchyId == selectedSubAccountHierarchyIds)
                        ?.SubAccounts || [];
                for (const item of subAccounts) {
                    list.push(item.HierarchyId);
                }
                selectedSubAccountHierarchyIds = list.join(",");
            }
            DocumentAction.get(
                [selectedSubAccountHierarchyIds],
                _from,
                _to,
                searchquery,
                minRow,
                maxRow,
                taskRequestIds,
                (result: DocumentsLibrary) => {
                    if (taskRequestIds && taskRequestIds.length > 0) {
                        const documentLibrary: DocumentsLibrary = Objects.cloneObject(this.state.data);
                        const documentList: Document[] = documentLibrary.Documents;
                        taskRequestIds.map((item, idx) => {
                            const docIndex = documentList.findIndex((x) => x.TaskRequestId == item);
                            if (docIndex > -1) {
                                documentList.splice(docIndex, 1);
                            }
                        });
                        (result.Documents || []).map((item, idx) => {
                            documentList.push(item);
                        });
                        documentList.sort((a, b) => {
                            if (a.Id > b.Id) {return -1;}
                            if (a.Id < b.Id) {return 1;}
                            return 0;
                        });
                        documentLibrary.Documents = documentList;
                        this.setState({
                            data: documentLibrary,
                            isLoading: false,
                        });
                    } else {
                        this.setState({
                            data: result,
                            isLoading: false,
                        });
                    }
                }
            );
        }
    }

    private rendertable() {
        const { data, isLoading, currentPage } = this.state;
        if (isLoading || !data) {
            return <LoadingSkeleton type={LoadingSkeletonType.Table} />;
        } else if (data && data.Documents.length == 0) {
            return <Alert alertType={AlertType.Warning} message={Constants.NoInvestmentDataErrorMessage} />;
        } else {
            return (
                <>
                    <Table
                        data={data.Documents}
                        col={this.tableColConfig(data)}
                        needPagination={{
                            totalNumOfResult: data.TotalRows,
                            currentPage: currentPage,
                            onPaginationChange: (pageIndex, pageSize) => {
                                this.setState(
                                    {
                                        currentPage: pageIndex,
                                    },
                                    () => {
                                        this.getDocuments(this.state.selectedHierarchyId);
                                    }
                                );
                            },
                        }}
                    />
                    {this.renderErrorMessage()}
                </>
            );
        }
    }

    private documentDownloadEvent(document: Document) {
        this.addEvent({
            event: "documentDownload",
            document: {
                title: document.DisplayName,
                url: `/popups/loaddocstore.aspx?filename=${document.FileNameEncryption}&encrypt=yes`,
                id: document.Id.toString(),
            },
        });
    }

    private tableColConfig(documentData: DocumentsLibrary): ITableConfig[] {
        const { selectedHierarchyId } = this.state;

        return [
            {
                title: "ID",
                key: "Id",
            },
            {
                title: "Document",
                key: "DisplayName",
                thCssWrapper: "cell-25",
                render: (data, row: Document, index) => {
                    if (row.Status.toLowerCase() !== "complete" && row.Status.toLowerCase() !== "created" && row.Status.toLowerCase() !== "sentclient")
                        {return row.DisplayName;}
                    return (
                        <button
                            className={"hyperlink text-left"}
                            onClick={(v) => {
                                this.documentDownloadEvent(row);
                                this.openDocument(row, v);
                            }}
                        >
                            {row.DisplayName}
                        </button>
                    );
                },
            },
            this.state.selectedHierarchyId
                ? null
                : {
                      title: "Quote Reference",
                      key: "QuoteReference",
                      render: (data, row: Document, index) => {
                          return row.QuoteReference ? row.QuoteReference : "-";
                      },
                  },
            {
                title: "AccountId",
                key: "ClAccountID",
            },
            {
                title: "Type",
                key: "Type",
                render: (data, row: Document, index) => {
                    return this.convertType(row.Type);
                },
            },
            {
                title: "Date",
                key: "AddedOn",
                render: (data, row: Document, index) => {
                    return JsonDateParser.getFormatDate(row.AddedOn,"dd/MM/yyyy hh:mm:ss");
                },
            },
            {
                title: "Report status",
                key: "Status",
            },
            {
                title: "Archive status",
                key: "Status",
                render: (data, row: Document, index) => {
                    if (!selectedHierarchyId) {
                        return null;
                    }
                    const isEditable = documentData.CanEdit && row.Type.Name != "Direct Portal";
                    const isEditDirectPortal = documentData.CanEditDirectPortal && row.Type.Name == "Direct Portal";
                    if (isEditable || isEditDirectPortal) {
                        return (
                            <SelectEditor
                                key={row.Id + Guid.getNext()}
                                options={DocumentStatusTypeToMap.map((x) => x.key)}
                                label="Archive status"
                                getText={(key) => CommonHelper.getOptionsTxt(key, DocumentStatusTypeToMap)}
                                selected={row?.DocStatus}
                                cssWrapper="control-size-200 mb-0 label-sr-only"
                                onChange={(v) => {
                                    this.updateDocStatus(this.GetHeadHierarchyId(row.ClAccountID), row.Id, v);
                                }}
                            />
                        );
                    } else {
                        return null;
                    }
                },
            },
            {
                title: "Download",
                key: "Type",
                render: (data, row: Document, index) => {
                    return (
                        <button type="button" className={"download-button"} onClick={() => this.downLoadOrDelete(row)}>
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">{"Download"}</span>
                        </button>
                    );
                },
            },
        ];
    }

    private openDocument(row: Document, event) {
        window.open(`/popups/loaddocstore.aspx?filename=${row.FileNameEncryption}&encrypt=yes`, "_blank");
    }

    private renderErrorMessage(): JSX.Element {
        const { isShowErrorMessage } = this.state;
        if (isShowErrorMessage) {
            return (
                <div>
                    <p>
                        <ErrorMessagePopup
                            showPopup={isShowErrorMessage}
                            errorMessage={this.state.errorMessage}
                            onClose={this.closeErrorMessagePopup}
                        />
                    </p>
                </div>
            );
        }
    }
    private GetHeadHierarchyId(clAccountId: string) {
        if (!clAccountId) {return;}
        let allAccounts = PortfolioDashboardStore.getFullAccounts();

        if (isConsolidate()) {
            const consolidatedAccountData = ConsolidatedAccountStore.getData();
            if (Array.isArray(consolidatedAccountData)) {
                allAccounts = allAccounts.concat(consolidatedAccountData);
            } else {
                allAccounts.push(consolidatedAccountData);
            }
        }

        if (clAccountId.indexOf("-") <= 0) {
            const hierarchyId = allAccounts.find((a) => a.HeadClAccountId == clAccountId)?.HierarchyId;
            if (hierarchyId) {return hierarchyId;}
        }
        let subaccounthierarchyId = "";
        allAccounts.forEach((x) => {
            const subaccount = (x.SubAccounts || [])?.find((a) => a.ClAccountId == clAccountId);
            if (subaccount) {
                subaccounthierarchyId = subaccount.HierarchyId;
            }
        });
        return subaccounthierarchyId;
    }

    private downLoadOrDelete(row: Document) {
        const { selectedHierarchyId } = this.state;

        //Download document
        this.documentDownloadEvent(row);

        if (!selectedHierarchyId) {
            DocumentFileAction.getProspectDocument(
                this.props.customerid,
                row.FileNameEncryption,
                false,
                row.Id,
                row.TaskRequestId ?? 0,
                (result) => {
                    if (!result) {
                        this.setState({
                            isShowErrorMessage: true,
                            errorMessage: Constants.Error_FileFailToLoad,
                        });
                    } else {
                        window.open(result);
                        this.getDocuments(this.state.selectedHierarchyId);
                    }
                },
                true
            );
        } else {
            DocumentFileAction.get(
                this.GetHeadHierarchyId(row.ClAccountID),
                row.FileNameEncryption,
                false,
                row.Id,
                row.TaskRequestId ?? 0,
                row.ClAccountID,
                (result) => {
                    if (result !== null && result !== "") {
                        this.handleReadDocument(this.GetHeadHierarchyId(row.ClAccountID), row.Id, result);
                    } else {
                        this.setState({
                            isShowErrorMessage: true,
                            errorMessage: Constants.Error_FileFailToLoad,
                        });
                    }
                },
                true
            );
        }
    }

    private updateDocStatus(hierarchyId, documentId, status) {
        DocumentAction.put(hierarchyId, documentId, status, (callBack: ServiceValidationError[]) => {
            if (callBack.length > 0) {
                this.setState({ isShowErrorMessage: true, errorMessage: callBack.map((ele) => ele.UserMessage)[0] });
            } else {
                this.getDocuments(this.state.selectedHierarchyId);
            }
        });
    }

    private handleReadDocument(hierarchyId, id: number, result) {
        DocumentFileAction.post(hierarchyId, id, (callBack: ServiceValidationError[]) => {
            if (callBack.length > 0) {
                this.setState({ isShowErrorMessage: true, errorMessage: callBack.map((ele) => ele.UserMessage)[0] });
            } else {
                window.open(result);
                this.getDocuments(this.state.selectedHierarchyId);
            }
        });
    }

    private convertType(type: DocumentType) {
        const option = DocumentTypeOptions.filter((o) => o.key === type.Id.toString());
        if (option && option.length > 0) {return option[0].value;}
    }

    closeErrorMessagePopup = () => {
        this.setState({ isShowErrorMessage: false });
    };

    handleFilterChange = (documentType: Dictionary[]) => {
        if (documentType.length == 0) {
            this.setState({
                data: { Documents: [] },
                isLoading: false,
            });
            return;
        }
        const updatedfilter = documentType;
        for (const key in documentType) {
            updatedfilter[key] = documentType[key];
        }

        this.setState(
            {
                currentPage: 1,
                documentType: updatedfilter,
            },
            () => {
                this.getDocuments(this.state.selectedHierarchyId);
            }
        );
    };

    private renderFileUpLoader() {
        if (this.state.isPopUp) {
            const allAccounts = PortfolioDashboardStore.getFullAccounts();
            return (
                <>
                    <FileUploader
                        isPopUp={this.state.isPopUp}
                        clAccountId={
                            allAccounts.find((a) => (a.HierarchyId == this.state.headAccountSelected)).HeadClAccountId
                        }
                        onClose={() => {
                            this.setState({ isPopUp: false, currentPage: 1 });
                            this.getDocuments(this.state.selectedHierarchyId);
                        }}
                    />
                </>
            );
        }
    }

    private renderMpsStatementMessage() {
        const { isLoading } = this.state;
        if (CookieHelper.getCookie("IsMpsJump")) {
            if (!isLoading) {
                CookieHelper.eraseCookie("IsMpsJump", "/");
            }
            return (
                <>
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            "Managed Portfolio Statement are produced overnight and will be available in the following day"
                        }
                    />
                </>
            );
        }
    }

    private handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const { headAccountSelected, selectedHierarchyId } = this.state;

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {context.customerId = customerHierarchyId;}
        if (headAccountSelected) {context.accountGroupId = headAccountSelected;}
        // handle scenario of head account selected
        if (selectedHierarchyId && headAccountSelected !== selectedHierarchyId) {context.accountId = selectedHierarchyId;}

        (window as any).AppStore.open(context);
    }

    public render(): JSX.Element {
        const { from, to, dateSelected, documentType, headAccountSelected, selectedHierarchyId } = this.state;
        const isConsolidated = isConsolidate();
        const { minDate, isDisable } = DateRange.getLeastDate(selectedHierarchyId, isConsolidated);
        const minDateWithoutTime = this.getMinDateWithoutTime(minDate);
        const { isPresentationView } = this.context;
        const inProgressAcount = PortfolioDashboardStore.getInProgressAccounts();
        const allAccounts = orderHeadAccountGroupByInvestorType(PortfolioDashboardStore.getData());
        const multiSelection = PortfolioDashboardMultiSelectionStore.getData();
        const quickQuote: ClientAccount = {
            AccountName: "Quick quote",
            HeadClAccountId: "",
        };
        let selectedHeadAccountsArray = [quickQuote]
            .concat(selectedHeadAccounts(multiSelection, allAccounts))
            .concat(inProgressAcount);

        const subaccountViewDic: Dictionary[] = [];
        if (isConsolidate()) {
            selectedHeadAccountsArray = [ConsolidatedAccountStore.getData()].concat(selectedHeadAccountsArray);
        }
        if (headAccountSelected == ConsolidatedAccountStore.getData()?.HierarchyId) {
            subaccountViewDic.push({ key: headAccountSelected, value: "Portfolio view" });
        } else {
            const allSubAccounts =
                selectedHeadAccountsArray.find((o) => o.HierarchyId == headAccountSelected)?.SubAccounts || [];
            const subAccounts = allSubAccounts.filter((ele) =>
                PortfolioDashboardMultiSelectionStore.getData().includes(ele.HierarchyId)
            );
            if (allSubAccounts.length == subAccounts.length) {
                subaccountViewDic.push({ key: headAccountSelected, value: "Portfolio view" });
            }
            subAccounts?.forEach((item) => {
                const accoutNum = " " + item.ClAccountId.substr(item.ClAccountId.indexOf("-") + 1);
                const _value = item.ProductDisplayName + accoutNum;
                subaccountViewDic.push({ key: item.HierarchyId, value: _value });
            });
        }

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;
        return (
            <div role={isPresentationView ? "main" : "tabpanel"} id="panel-6" tabIndex={0} aria-labelledby="tab-6">
                <div className="ad d1">
                    <Alert
                        alertType={AlertType.Warning}
                        message={"Please note that only 1 account can be selected at a time on this page."}
                    />
                    {this.renderMpsStatementMessage()}
                    <div className="row narrow-gutter">
                        <div className="col-12 col-md-4">
                            <SelectEditor
                                key="HeadAccountView"
                                label="Select account"
                                selected={this.state.headAccountSelected}
                                options={selectedHeadAccountsArray.map((x) => x.HierarchyId)}
                                getText={(x) => {
                                    const account = selectedHeadAccountsArray.find((o) => o.HierarchyId == x);
                                    return `${account?.AccountName} ${account?.HeadClAccountId}`;
                                }}
                                onChange={(val) => {
                                    this.addEvent({
                                        event: "documenttab_interaction",
                                        eventParameters: {
                                            eventAction: "interactions",
                                            eventCategory: eventCategoryForGTM.documentTab,
                                            eventLabel: "select account",
                                        },
                                    });
                                    const allSubAccounts =
                                        selectedHeadAccountsArray.find((o) => o.HierarchyId == val)?.SubAccounts || [];
                                    const subAccounts = allSubAccounts.filter((ele) =>
                                        PortfolioDashboardMultiSelectionStore.getData().includes(ele.HierarchyId)
                                    );
                                    let _sub = val;
                                    if (allSubAccounts.length !== subAccounts.length) {
                                        _sub = subAccounts?.[0].HierarchyId;
                                    }

                                    this.setState(
                                        {
                                            headAccountSelected: val,
                                            selectedHierarchyId: _sub,
                                        },
                                        () => this.getDocuments(this.state.selectedHierarchyId)
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div className="row narrow-gutter">
                        {this.state.selectedHierarchyId && (
                            <div className="col-12 col-md-4">
                                <SelectEditor
                                    key="SubAccountView"
                                    label="Select view"
                                    selected={
                                        this.state.selectedHierarchyId
                                            ? this.state.selectedHierarchyId
                                            : this.state.headAccountSelected
                                    }
                                    options={subaccountViewDic.map((ele) => ele.key)}
                                    getText={(x) => CommonHelper.getOptionsTxt(x, subaccountViewDic)}
                                    onChange={(val) => {
                                        this.addEvent({
                                            event: "documenttab_interaction",
                                            eventParameters: {
                                                eventAction: "view selector",
                                                eventCategory: eventCategoryForGTM.documentTab,
                                                eventLabel: CommonHelper.getOptionsTxt(
                                                    val,
                                                    subaccountViewDic
                                                ).toLowerCase(),
                                            },
                                        });
                                        this.setState(
                                            {
                                                selectedHierarchyId: val,
                                            },
                                            () => this.getDocuments(this.state.selectedHierarchyId)
                                        );
                                    }}
                                />
                            </div>
                        )}
                        <div className="col-12 col-md-8">
                            <DateRange
                                disabled={isDisable}
                                minDate={null}
                                fromDate={from}
                                toDate={to}
                                cssGridDate="col-6 col-md-4"
                                cssGridTo="col-3 col-md-4"
                                cssGridFrom="col-3 col-md-4"
                                cssGridLabel="col-6  col-middle"
                                selectValue={dateSelected}
                                excludeSinceAccountOpening={!this.state.selectedHierarchyId}
                                onChange={(
                                    fromDate: Date,
                                    toDate: Date,
                                    fromInception: boolean,
                                    dateSelected: string
                                ) => {
                                    if (dateSelected != this.state.dateSelected) {
                                        this.addEvent({
                                            event: "documenttab_interaction",
                                            eventParameters: {
                                                eventAction: "date range selector",
                                                eventCategory: eventCategoryForGTM.documentTab,
                                                eventLabel: CommonHelper.getOptionsTxt(
                                                    dateSelected,
                                                    DateOptions
                                                ).toLowerCase(),
                                            },
                                        });
                                    }

                                    this.setState(
                                        {
                                            from: fromInception ? minDateWithoutTime : fromDate,
                                            to: toDate,
                                            dateSelected: dateSelected,
                                            fromInception: fromInception,
                                        },
                                        () => this.getDocuments(this.state.selectedHierarchyId)
                                    );
                                }
                            }
                            />
                        </div>
                        <div className="col-12 col-lg-fluid col-bottom">
                            <div className="row narrow-gutter row-right mb-24">
                                <div className="col-auto">
                                    <button
                                        type="button"
                                        title="Upload document(s)"
                                        className="upload-button"
                                        onClick={() => {
                                            this.addEvent({
                                                event: "documenttab_interaction",
                                                eventParameters: {
                                                    eventAction: "interactions",
                                                    eventCategory: eventCategoryForGTM.documentTab,
                                                    eventLabel: "upload",
                                                },
                                            });
                                            this.setState({ isPopUp: true });
                                        }}
                                    >
                                        <span className="text sr-only"> Upload document(s)</span>
                                        <span className="icon" aria-hidden="true"></span>
                                    </button>
                                </div>
                                <div className="col-auto">
                                    <DocumentsFilters
                                        type={documentType}
                                        event={{
                                            event: "documenttab_interaction",
                                            eventParameters: {
                                                eventAction: "interactions",
                                                eventCategory: eventCategoryForGTM.documentTab,
                                                eventLabel: "filter click",
                                            },
                                        }}
                                        handleFilterChange={(documentType) => this.handleFilterChange(documentType)}
                                    />
                                </div>
                                {!isPresentationView && (
                                    <div className="col-auto col-middle">
                                        <FullScreenTableModeButton
                                            onClick={() => {
                                                this.addEvent({
                                                    event: "documenttab_interaction",
                                                    eventParameters: {
                                                        eventAction: "interactions",
                                                        eventCategory: eventCategoryForGTM.documentTab,
                                                        eventLabel: "expand",
                                                    },
                                                });
                                            }}
                                        >
                                            {this.rendertable()}
                                        </FullScreenTableModeButton>
                                    </div>
                                )}
                                <div className="col-auto col-middle">
                                    <PresentationViewButton
                                        onClick={() => {
                                            this.addEvent({
                                                event: "documenttab_interaction",
                                                eventParameters: {
                                                    eventAction: "interactions",
                                                    eventCategory: eventCategoryForGTM.documentTab,
                                                    eventLabel: "presentation mode",
                                                },
                                            });
                                            this.props.onPresentationViewStatusChange(
                                                portfolioDashboardTabEnum.Documents,
                                                this.props.isBtnPresentationClicked
                                            );
                                        }}
                                    />
                                </div>
                                {isAppStoreEnabled && (
                                    <div className="col-auto col-middle">
                                        <button
                                            type="button"
                                            className="applications-pad-button"
                                            onClick={this.handleLaunchpadClick.bind(this)}
                                        >
                                            <span className="sr-only">Applications pad</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {this.rendertable()}
                    {this.renderFileUpLoader()}
                </div>
            </div>
        );
    }
}
PortfolioDashboardDocuments.contextType = PresentationContext;
